module.exports = __webpack_public_path__ + "img/travel2.ef446fd7.gif";